import { WithToggleSwitch, WithToggleSwitchProps } from '@components/design/WithToggleSwitch';
import { WithMultiSelect, WithMultiSelectProps } from '@components/design/WithMultiSelect';
import React from 'react';

export interface ExclusionProps {
  isAvailable: boolean; // is the toggle be shown
  isActive: boolean; // is toggle active or not
}

export interface WithMultiSelectToggleProps {
  exclusion?: ExclusionProps;
  toggleSwitchProps?: WithToggleSwitchProps;
  multiSelectProps: WithMultiSelectProps;
}

export const WithMultiSelectToggle: React.FC<WithMultiSelectToggleProps> = ({
  exclusion,
  toggleSwitchProps,
  multiSelectProps,
}) => {
  return (
    <div>
      {exclusion?.isAvailable && toggleSwitchProps && <WithToggleSwitch {...toggleSwitchProps} />}
      <WithMultiSelect {...multiSelectProps} />
    </div>
  );
};
